<template>
  <div class="post-message-box show-flex-box-c show-flex-center" v-if='isShowPostMessage'>
    <ul class="post-center-box">
      <li class="post-top-title">
        <h3 class="show-flex-box-r">
          <em></em>
          <strong>发帖</strong>
          <span @click="showOrhidePop"></span>
        </h3>
      </li>
      <li class="post-input-titlt">
        <span><input type="text" placeholder="请输入帖子标题" v-model='postTitle' @input= "getTitleAccoutNum"></span>
      </li>
      <li class="post-input-content">
        <post-content :catchData="getPostContent"></post-content>
      </li>
      <li class="post-class-list">
        <h4>选择分类</h4>
        <div class="post-class-detail" v-if='forumClass'>
          <post-class @choosePostClass= 'getPostKind' :forumKinds= 'forumClass'></post-class>
        </div>
      </li>
      <li class="post-submit">
        <strong @click="postMessage">发布</strong>
      </li>
    </ul>
  </div>
</template>

<script>
import postContent from "@/components/post_message/post_content_cpn"
import postClass from "@/components/post_message/post_class_cpn"

export default {
  name: 'post_message',
  inject: ['reload'],
  props:{
    'forumKind': [String,Object]
  },
  data () {
    return {
      isShowPostMessage: false,
      postTitle: '',     //帖子标题
      forumClass: false,
      postKind: '',   //选择的板块
      postText: ''    //发送的帖子内容
    }
  },
  components:{
    postContent,
    postClass
  },
  mounted() {
    this.setFormKind();
  },
  methods: {
    getTitleAccoutNum: function() {
      if (this.postTitle.length > 50) {
        this.$elementMsg.error({
          'message': '输入字数不能超过50字',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
        })
      };
      this.postTitle = this.postTitle.slice(0,50);
    },
    setPageScrollStatus: function() {
      if (this.isShowPostMessage) {
        $('body').css({"overflow":'hidden'});
      } else {
        $('body').css({'overflow':'auto'})
      }
    },
    showOrhidePop: function() {
      this.isShowPostMessage = !this.isShowPostMessage;
      this.postTitle = '';
      this.setPageScrollStatus();
    },
    // 获取输入的帖子内容
    getPostContent: function(postContent) {
      this.postText = postContent;
    },
    postMessage: function() {
      let msgTitle = this.postTitle;
      let msgKind = this.postKind.id;
      let postText = this.postText;
      if (this.forumKind == 'forum') {
        var test = {
          'title': msgTitle,
          'content': postText,
          'cate_id': msgKind
        };
        this.$client.postingPost(test)
        .then((res) => {
          if (res.code == '200' || res.code == 200) {
            this.showOrhidePop();
            this.$elementMsg.success({
              'message': '发布成功',
              'showClose':true,
              'customClass': 'pop-class-success',
              'duration': 3000
            });
            this.reload();
          }
        }).catch((err) => {

        })
      } else if (this.forumKind == 'teacherForum') {
        var test = {
          'title': msgTitle,
          'content': postText,
          'organ_post_cate_id': msgKind
        };
        this.$client.postingTeacherPost(test)
        .then((res) => {
          if (res.code == '200' || res.code == 200) {
            this.showOrhidePop();
            this.$elementMsg.success({
              'message': '发布成功',
              'showClose':true,
              'customClass': 'pop-class-success',
              'duration': 3000
            });
            this.reload();
          }
        }).catch((err) => {

        })
      }
    },
    setFormKind: function() {
      this.forumClass = this.forumKind;
    },
    //获取选择的板块
    getPostKind: function(data) {
      this.postKind = data;
    }
  },
  watch: {
    forumKind: function() {
      this.setFormKind();
    },
    postTitle:function() {
      this.getTitleAccoutNum();
    }
  }
}
</script>

<style lang="less" scoped>
  .post-message-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    .post-center-box {
      overflow: hidden;
      width: 860px;
      background: #fff;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      .post-top-title {
        height: 70px;
        border-bottom: 1px solid #dedede;
        &>h3 {
          height: 100%;
          padding-left: 66px;
          padding-right: 66px;
          justify-content: space-between;
          align-items: center;
          &>strong {
            display: block;
            font-size: 20px;
            color: #555;
          }
          &>span,&>em {
            display: block;
            width: 28px;
            height: 28px;
          }
          &>span {
            background: url("../../assets/common/close_btn.png") center no-repeat;
            background-size: 18px 18px;
            cursor: pointer;
          }
          &>span:hover {
            background: url("../../assets/common/close_btn_hover.png") center no-repeat;
            background-size: 28px 28px;
          }
        }
      }
      .post-input-titlt,
      .post-input-content,
      .post-class-list {
        padding-left: 60px;
        padding-right: 60px;
      }
      .post-input-titlt {
        padding-top: 20px;
        padding-bottom: 10px;
        &>span {
          display: block;
          height: 50px;
          border-radius: 10px;
          padding: 5px 10px;
          border: 1px solid #dedede;
          &>input {
            display: block;
            width: 100%;
            height: 100%;
            font-size: 18px;
            border: none;
            outline: none;
            background: none;
            color: #555;
          }
          &>input::-webkit-input-placeholder {
            color: #999;
          }
        }
      }
      .post-input-content {
        height: 254px;
      }
      .post-class-list {
        padding-top: 18px;
        &>h4 {
          font-size: 18px;
          text-align: left;
          font-weight: normal;
          margin-bottom: 20px;
          color: #555;
        }
        .post-class-detail {
          
        }
      }
      .post-submit {
        // padding-top: 20px;
        padding-bottom: 28px;
        &>strong {  
          display: block;
          width: 254px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border-radius: 30px;
          margin: 0 auto;
          background: #ff7800;
          cursor: pointer;
          color: #fffffe;
        }
        &>strong:hover {
          background: #ce7400;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/post_message/post_message.vue